import {
  query,
  where,
  updateDoc,
  getDocs,
  getDoc,
  onSnapshot,
  addDoc,
  deleteDoc,
} from "firebase/firestore";
import { deleteProduct } from "../products/productsApi";
import { getDocumentRef, getCollectionRef } from "../utils";

/**
 * Get all categories of a specific admin
 * @param {string} adminId
 */
async function getAllCategoriesOfAdmin(adminId) {
  const categoriesRef = getCollectionRef("categories");
  const adminRef = getDocumentRef("admins", adminId);
  const q = query(categoriesRef, where("creatorOfCategory", "==", adminRef));
  try {
    const adminCategories = await getDocs(q);
    return { data: adminCategories };
  } catch (err) {
    console.log(err);
    return { error: "error while getting admin categories" };
  }
}

/**
 * create category on firestore database
 * @param {object} data
 * @returns data | error
 */
async function createCategory(data) {
  const { name, image, starsNumber, creatorOfCategory } = data;

  const categoriesRef = getCollectionRef("categories");

  try {
    const docRef = await addDoc(categoriesRef, data);
    if (docRef.id) return { data: true };
  } catch (err) {
    console.log(err);
    return { error: "error while creating category" };
  }
}

/**
 * Get all the categories in firebase database
 * @returns data | error
 */
async function getAllCategories(globalStateAddAllCategories = (data) => {}) {
  //ref gatégories collection
  const categoriesRef = getCollectionRef("categories");
  const categories = [];

  try {
    //get realtime snapshot of categories collection
    onSnapshot(categoriesRef, async (categoriesSnapshot) => {
      categoriesSnapshot.forEach((doc) => {
        const name = doc.data().name.toLowerCase();
        const category = { ...doc.data(), name, id: doc.id };
        categories.push(category);
      });

      // add all categories to global state
      globalStateAddAllCategories(categories);
      return { data: "category added to global state" };
    });
  } catch (err) {
    console.log(err);
    return { error: "And eror occured while getting all categories" };
  }
}

/**
 * Get a single category from firebase database
 * @param {string} id
 * @returns
 */
const getCategory = async (id) => {
  const categoryRef = getDocumentRef("categories", id);
  try {
    const doc = await getDoc(categoryRef);
    if (doc.exists()) return { category: doc.data(), id: doc.id };
  } catch (err) {
    console.log(err);
    return { error: "error while getting a single category" };
  }
};

/**
 * update the category on firebase database
 * @param {string} idCategory
 * @param {Object} data
 * @returns
 */
const updateCategoy = async (idCategory, data) => {
  //ref to the category to update
  const categoryRef = getDocumentRef("categories", idCategory);

  try {
    //update the category
    await updateDoc(categoryRef, { ...data });

    return { data: true };
  } catch (err) {
    console.log(err);
    return { error: "And error occured while updating the category" };
  }
};

/**
 * delete category on firebase database
 * @param {string} id
 * @returns
 */
const deleteCategory = async (id) => {
  console.log(id);
  //doc ref
  const categoryRef = getDocumentRef("categories", id);

  //query to get all products of this category
  const q = query(
    getCollectionRef("products"),
    where("categoryMembership", "==", categoryRef)
  );

  try {
    //get all products of this category
    const products = await getDocs(q);

    //delete all products of this category
    products.forEach(async (product) => {
      await deleteProduct(product.id);
    });

    //delete category
    await deleteDoc(categoryRef);
    return { data: true };
  } catch (err) {
    console.log(err);
    return { error: "error while deleting category" };
  }
};

export {
  getAllCategoriesOfAdmin,
  createCategory,
  getAllCategories,
  updateCategoy,
  deleteCategory,
  getCategory,
};
